import log from 'loglevel';

const AD_CRITTER_SCRIPT_URL = 'https://apxl.io/script.js';
const AD_CRITTER_CONFIG = "3289d26d-d660-4829-a3f2-a6be23184142";

// https://betterprogramming.pub/loading-third-party-scripts-dynamically-in-reactjs-458c41a7013d
const loadAdCritterScripts = (callback) => {
  const existingScript = document.getElementById('adCritterScriptElement');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = AD_CRITTER_SCRIPT_URL;
    script.id = 'adCritterScriptElement';
    document.body.appendChild(script);
    script.onload = () => {
      window.apxlTag.config(AD_CRITTER_CONFIG);
      if (callback) {
        callback();
      }
    };
  }
  if (existingScript && callback) {
    callback();
  }
};

const parseAdvertisingQueryParams = (sessionContext, setSessionContextState) => {
  const searchParams = new URLSearchParams(window.location.search);
  log.debug(`AdCritter:`, searchParams);
  if (!searchParams.has("utm_source") || (
      searchParams.get("utm_source") !== "adcritter" && searchParams.get("utm_source") !== "google")) {
    log.debug(`AdCritter: no ad Critter params found`);
    return;
  }
  log.debug(`AdCritter: Found AdCritter attribution parameters.`, searchParams.get("utm_source"));
  const { advertisingAttribution = {} } = sessionContext;
  const {
    acid,
    utmSource,
    utmMedium
  } = advertisingAttribution;

  if (acid === searchParams.get("acid")
      && utmSource === searchParams.get("utm_source")
      && utmMedium === searchParams.get("utm_medium")) {

    log.debug(`AdCritter: already set, done.`);
    return;
  }
  const newSessionContext = {
    ...sessionContext,
    advertisingAttribution: {
      acid: searchParams.get("acid"),
      utmSource: searchParams.get("utm_source"),
      utmMedium: searchParams.get("utm_medium")
    }
  };
  setSessionContextState(newSessionContext);
};

const adCritterConversion = () => {
  try {
    log.debug(`adCritterConversion`);
    window.apxlTag.event("conversion");
  } catch (error) {
    log.error(error);
  }
};

export {
  loadAdCritterScripts,
  parseAdvertisingQueryParams,
  adCritterConversion
};
